var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade-transition"}},[(_vm.$route.name === 'Reports')?[_c('app-lacuna',{attrs:{"icon":"reports","title":_vm.$t('reports'),"text":_vm.$t('please_select_an_item_from_the_menu')}})]:_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }